import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';

export const DiagramApi = {
  async getDiagramGraph({ resource }) {
    const splitResource = `${resource}`.split('?');
    let params = null;

    if (splitResource.length > 1) {
      params = splitResource[1];
    }

    let url = splitResource[0] + '/diagram';
    if (params) url += `?${params}`;

    return (await checkErrors(await fetchApi.api.get(url, {}))).data;
  },
};

export default DiagramApi;
